import type { ServiceName } from '~~/shared/utils/services'

export const useGetServiceHref = () => {
  const host = useHost()
  const runtimeConfig = useRuntimeConfig()
  const isTesting = useIsTesting()

  return ({
    allowInternal = true,
    name,
  }: {
    allowInternal?: boolean
    name: ServiceName
  }) =>
    getServiceHref({
      allowInternal,
      host,
      isTesting,
      name,
      stagingHost: runtimeConfig.public.vio.stagingHost,
    })
}

export const useHost = () => {
  const { ssrContext } = useNuxtApp()
  const host = ssrContext ? getHost(ssrContext.event) : location.host

  if (!host) throw new Error('Host is not given!')

  return host
}

export const useHttpStatusCode = async ({ status }: { status: number }) => {
  const { locale, t } = useI18n({ useScope: 'global' })

  const { status: statusText } = await import('@http-util/status-i18n')
  const statusName = computed(
    () => statusText(status, locale.value) || t('globalError'),
  )

  return {
    statusName,
  }
}

export const useIsSecure = () =>
  getIsSecure({ siteUrl: useSiteUrl().siteUrlTyped })

export const useSiteUrl = () =>
  getSiteUrl(useRuntimeConfig().public.i18n.baseUrl)

export const useTusdFilesUrl = () => {
  const getServiceHref = useGetServiceHref()

  return `${getServiceHref({ allowInternal: false, name: 'tusd' })}/files/`
}
